import { CURRENT_WAIVER_RETRIEVED, WAIVER_LOADING_FAILED, WAIVER_REQUESTED, } from "../constants";
import moment from 'moment'


export const currentWaiver = (state = {}, action) => {
  switch (action.type) {
    case CURRENT_WAIVER_RETRIEVED:
      //  return action.payload
      return Object.assign({}, state, action.payload, { loading: false, pdfExpires: moment().add(40, 'minutes') })
    case WAIVER_LOADING_FAILED:
      //   return { ...state, message: action.payload.message }
      return Object.assign({}, state, { message: action.payload, waiverId: -1, loading: false })
    case WAIVER_REQUESTED:
      return Object.assign({}, state, { loading: true })

    default:
      return state;
  }
};
